export default __webpack_public_path__ + "static/media/people-ico.cc380d14.svg";